export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";